import gql from 'graphql-tag';

export const GET_ADMIN_AGENTS = gql`
	query GetAdminAgents($query: JSON, $limit: Int, $offset: Int, $order: [[String]]) {
		users(query: $query, limit: $limit, offset: $offset, order: $order) {
			id
			name
			email
			phoneNumber
			image
			role
		}
	}
`;
